import PropTypes from 'prop-types';
import React from 'react';

import styles from './ApplicantTabs.module.scss';

const ApplicantTabs = ({
  tabs,
  activeTab,
  tabRefs,
  loadingPitches,
  onTabChange,
  getTabCount,
}) => {
  return (
    <div className={styles.tabsContainer}>
      <div className="container">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            ref={(el) => (tabRefs.current[tab.id] = el)}
            onClick={() => onTabChange(tab.id)}
            className={`${styles.tab} ${
              activeTab === tab.id ? styles.tabActive : ''
            }`}
          >
            {tab.label}
            {loadingPitches ? '' : ` (${getTabCount(tab.id)})`}
          </button>
        ))}
      </div>
    </div>
  );
};

ApplicantTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  activeTab: PropTypes.string.isRequired,
  tabRefs: PropTypes.object.isRequired,
  loadingPitches: PropTypes.bool.isRequired,
  onTabChange: PropTypes.func.isRequired,
  getTabCount: PropTypes.func.isRequired,
};

export default ApplicantTabs;
